<template>
  <div class="recommendQuotationRightBar">
    <div class="header">
      <span style="font-weight: bold">{{l("热卖推荐")}}</span>
      <div class="refresh" @click="getRecommendList">
        <i class="el-icon-refresh-right"></i>
        {{l("换一批")}}
      </div>
    </div>
    <div class="recommendList">
      <router-link
        v-for="item of recommendList"
        :key="item.id"
        :to="'/home/quotation/' + item.code"
        target="_blank"
        class="quotationItem"
      >
        <el-image :src="item.img_array[0]" fit="cover"></el-image>
        <div class="labelList">
          <div v-if="item.character == 1" class="character_1">{{l("正品现货")}}</div>
          <div v-if="item.character == 2" class="character_2">{{l("二级余料")}}</div>
          <div v-if="item.character == 3" class="character_2">{{l("正品余料")}}</div>
        </div>
        <div class="detail">
          <div class="price one_lines">
            <template v-if="item.cheap_specification_price.price == '电议'">
              {{l("价格电议")}}
            </template>
            <template v-else>
              {{ item.cheap_specification_price.price }}{{l("元")}}/{{
                item.cheap_specification_price.unit
              }}
            </template>
          </div>
          <div class="title one_lines">
            <img :src="GetResourceUrl('flags/' + item.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
            {{ item.title }}
          </div>
          <div class="line one_lines">{{l("钢厂")}}：{{ item.steel_mill }}</div>
          <div class="line one_lines">{{l("发货地")}}：
            {{ item.address }}
          </div>
        </div>
      </router-link>
    </div>
    <!-- <div v-show="showTip" class="tip">
      没找到想要的商品？试试发布求购吧
      <div
        class="myBtn"
        @click="
          $router.push({
            name: 'buyer_purchase_material',
            params: { command: 'create', quality_type: 1 },
          })
        "
      >
        发布求购
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "RecommendQuotationRightBar",
  props: {
    size: {
      type: Number,
      default: 5,
    },
    showTip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      recommendList: [],
    };
  },
  mounted() {
    this.getRecommendList();
  },
  methods: {
    getRecommendList() {
      this.axios
        .get("/api/visitor_quotation/recommend_list/", {
          params: {
            size: this.size,
          },
        })
        .then((data) => {
          this.recommendList = data.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.recommendQuotationRightBar {
  width: 248px;
  box-sizing: border-box;
  border: 1px solid $borderColor;
  background: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    line-height: 32px;
    height: 32px;
    padding: 0 14px 2px;
    .refresh {
      color: #666;
      font-size: 12px;
      cursor: pointer;
      i {
        cursor: pointer;
      }
    }
  }
  .quotationItem {
    width: 220px;
    height: 345px;
    margin: 0 auto 10px;
    cursor: pointer;
    position: relative;
    border: 1px solid $borderPlainColor;
    .el-image {
      width: 220px;
      height: 220px;
    }
    .labelList {
      color: #fff;
      position: absolute;
      font-size: 12px;
      text-align: center;
      left: 0;
      top: 0;
      div {
        width: 72px;
        height: 22px;
        line-height: 22px;
        border-bottom-right-radius: 10px;
      }
      .character_1 {
        background: $warningColor;
      }
      .character_2 {
        background: $themeColor;
      }
    }
    .detail {
      margin-top: 6px;
      margin-left: 10px;
      margin-right: 10px;
      .price {
        color: $warningColor;
        font-size: 17px;
        font-weight: bold;
        letter-spacing: 0.5px;
        height: 24px;
        line-height: 24px;
      }
      .title {
        font-size: 15px;
        font-weight: bold;
        line-height: 32px;
        height: 32px;
        margin: 2px 0;
      }
      .line {
        color: #666;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
  .tip {
    height: 144px;
    color: #9f9f9f;
    font-size: 12px;
    padding-top: 28px;
    box-sizing: border-box;
    text-align: center;
    .myBtn {
      border: 1px solid $warningColor;
      color: $warningColor;
      width: 96px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      margin: 20px auto 0;
      cursor: pointer;
      &:hover {
        color: #fff;
        background: $warningColor;
      }
    }
  }
}
</style>